import { DataSource } from '~/Api/DataSource';

export default class ComparativePriceProduct {
	id: string;

	dataSource: DataSource;

	constructor(id: string, dataSource: DataSource) {
		this.id = id;
		this.dataSource = dataSource;
	}
}
